/* eslint-disable react/jsx-boolean-value */
import React from 'react'
import { makeStyles} from "@material-ui/core/styles";
import {
  Dialog,
} from "@material-ui/core";

import Truckloading from "../../assets/images/loader.gif";
import styles from "./Cvloader.module.css";

function Cvloader() {

  const useStyles = makeStyles({
    paperWidthSm: {
      maxWidth: '600px',
      borderRadius:"50%"
    },
  });

  const classes = useStyles();

  return (
    <Dialog
           open={true}
           classes={{ paperWidthSm: classes.paperWidthSm }}
  
        >
            <img
       src={Truckloading}
       className={styles.imagedimesion}
       alt="loading..."
     />
            {/* </DialogContent>
          </> */}
        </Dialog>
  )}

export default Cvloader